import { createRoute, lazyRouteComponent } from "@tanstack/react-router";
import { authenticatedRoute } from '../../../pages/AuthenticatedView.route';

export const sourcesRoute = createRoute({
    getParentRoute: () => authenticatedRoute,
    path: "/reviews/$reviewId/sources",
    component: lazyRouteComponent(() => import('./Sources.page'))
});
